import { GenericField } from './generic-field';
import { GenericFieldString } from './generic-field-string';
import { GenericFieldNumber } from './generic-field-number';
import { LocaleService } from '../services/locale.service';

export class PraticheType {
	fieldsMap: Map<string, GenericField>;

	constructor(private formatter: LocaleService){
		this.onInit();
	}

	onInit(){
		let fieldLocal: GenericField;
		this.fieldsMap = new Map();

		fieldLocal = new GenericFieldNumber(this.formatter, "uid", "number");
		this.fieldsMap.set("uid", fieldLocal);

		fieldLocal = new GenericFieldString(this.formatter, "id_prat");
		this.fieldsMap.set("id_prat", fieldLocal);

		fieldLocal = new GenericFieldNumber(this.formatter, "anagrafica_id", "number");
		this.fieldsMap.set("anagrafica_id", fieldLocal);

		fieldLocal = new GenericFieldNumber(this.formatter, "comune_id", "number");
		this.fieldsMap.set("comune_id", fieldLocal);

		fieldLocal = new GenericFieldString(this.formatter, "emissione");
		this.fieldsMap.set("emissione", fieldLocal);
		this.setFieldValue("emissione", '');

		fieldLocal = new GenericFieldNumber(this.formatter, "stato_id", "number");
		this.fieldsMap.set("stato_id", fieldLocal);

		fieldLocal = new GenericFieldString(this.formatter, "stato");
		this.fieldsMap.set("stato", fieldLocal);
		this.setFieldValue("stato", '');

		fieldLocal = new GenericFieldString(this.formatter, "nominativo");
		this.fieldsMap.set("nominativo", fieldLocal);
		this.setFieldValue("nominativo", '');

		fieldLocal = new GenericFieldString(this.formatter, "notifica_data");
		this.fieldsMap.set("notifica_data", fieldLocal);
		this.setFieldValue("notifica_data", '');

		fieldLocal = new GenericFieldString(this.formatter, "notifica_scadenza");
		this.fieldsMap.set("notifica_scadenza", fieldLocal);
		this.setFieldValue("notifica_scadenza", '');

		fieldLocal = new GenericFieldNumber(this.formatter, "totale_pagato", "currency");
		this.fieldsMap.set("totale_pagato", fieldLocal);

		fieldLocal = new GenericFieldNumber(this.formatter, "totale_dovuto", "currency");
		this.fieldsMap.set("totale_dovuto", fieldLocal);

		fieldLocal = new GenericFieldNumber(this.formatter, "totale_residuo", "currency");
		this.fieldsMap.set("totale_residuo", fieldLocal);
    }

	getMap(){
		return this.fieldsMap;
	}

	clearField(key: string){
		this.fieldsMap.get(key).clear();
	}

	getFieldType(key: string){
		return this.fieldsMap.get(key).getType();
	}

    getFieldValue(key: string){
		if(this.fieldsMap.get(key)){
			return this.fieldsMap.get(key).getValue();
		}
	}

	getFieldString(key: string){
		if(this.fieldsMap.get(key)){
			return this.fieldsMap.get(key).getValueString();
		}
	}

	setFieldValue(key: string, value: any){
		if(this.fieldsMap.get(key)){
			this.fieldsMap.get(key).setValue(value);
			this.fieldsMap.get(key).toString(this.formatter);
		}
	}
};
